import GameObject from './../Core/GameObject'
import Vector from './../Support/Vector'

/**
 * Mob class
 *      - Base class for all living gameObjects
 */
export default class extends GameObject {
    constructor (location) {
        super(location)
        this._acceleration = new Vector(0, 0)
        this._alive = false
        this._color = null
        this._poisonous = false
        this._deathCallbacks = []
    }

    addTo (world) {
        super.addTo(world)
        this._alive = true
        return this
    }

    updatePosition () {
        this._velocity.add(this._acceleration)
        this._velocity.limit(2)
        this._location.add(this._velocity)
        this._acceleration.multiply(0)
        return this
    }

    applyForce (force) {
        this._acceleration.add(force)
        return this
    }

    moveTowards (target) {
        let force = target.clone().subtract(this._location)
        this.applyForce(force)
        this._velocity.limit(force.getMagnitude())
        return this
    }

    break () {
        this._velocity.divide(1.1)
        return this
    }

    stop () {
        this._velocity = new Vector(0, 0)
        this._acceleration = new Vector(0, 0)
        return this
    }

    isMoving () {
        return this._velocity.getMagnitude() > 0.2
    }

    isAlive () {
        return this._alive
    }

    isPoisonous () {
        return this._poisonous
    }

    makePoisonous () {
        this._poisonous = true
        return this
    }

    setColor (color, timeout = false) {
        this._color = color
        if (timeout) {
            this.game.setTickTimeout(() => {
                this._color = null
            }, timeout)
        }
    }

    die () {
        this._alive = false

        this._deathCallbacks.forEach(deathCallback => {
            deathCallback()
        })
        return this
    }

    onDeath (callback) {
        this._deathCallbacks.push(callback)

        return this
    }
}
